export const routesName = {
  LANDING: "landing",
  FIND_APPOINTMENT: "findappointment",
  ADDITIONAL_DETAILS: "additionaldetails",
  INSURANCE: "insurance",
  IDENTITY: "identity",
  // EXITING_PATIENT_FIND_APPOINTMENT: "exiting-patient/findappointment",
  INTAKE_QUESTION: "intakequestion",
  THANKYOU: "thankyou",
  VIRTUAL_CHECKIN: "virtualcheckin",
  WIDGET: "widget",

  //Admin
  ADMIN_LOGIN: "login",
  ADMIN_MANAGE_SCHEDULER: "managescheduler",
  ADMIN_CREATE_LINK: "createlink",
  ADMIN_PROVIDER_CONTROL: "providercontrol",
  ADMIN_PROVIDER_EDIT_CONTROL: "providercontroleditprovider",
  ADMIN_WAIT_LIST: "waitlist",
  ADMIN_SERVICE_CONTROL: "configservices",
  ADMIN_INSURANCE_CONTROL: "insuranceconfig",
  ADMIN_LOCATION_CONTROL: "locationconfig",
  ADMIN_REPORTS: "reports",
  ADMIN_ANALYTICS: "analytics",
  ADMIN_WIDGET: "widget",
  ADMIN_BLANK: "blank",
  ADMIN_PATIENTS: "patients",
  ADMIN_PATIENT_DETAILS: "patients/patientsdetails",
  PATIENT_DETAILS: "patientdetails",
  ALL_SCHEDULERS_LIST: "schedulersList",
  ADMIN_ALL_SCHEDULERS_LIST: "managescheduler/schedulersList",
};
